// Router paths remain relative to the app; browser redirects include its mount path.
export const APP_BASENAME = (process.env.REACT_APP_ROUTER_BASENAME || '').replace(/\/$/, '');

export function appPath(path = '/dashboard') {
  const relative = path === APP_BASENAME || path.startsWith(`${APP_BASENAME}/`)
    ? path.slice(APP_BASENAME.length) || '/'
    : path;
  return `${APP_BASENAME}${relative.startsWith('/') ? relative : `/${relative}`}`;
}

export function appUrl(path = '/dashboard') {
  return new URL(appPath(path), window.location.origin).toString();
}

export function isEmbeddedApp() {
  try {
    return window.parent !== window && window.parent.location.origin === window.location.origin;
  } catch {
    return false;
  }
}

let focusedStudio = false;
export function isFocusedStudio() {
  if (!isEmbeddedApp()) return false;
  if (new URLSearchParams(window.location.search).get('studio') === '1') focusedStudio = true;
  // Keep the presentation when signup/profile routes change the query string.
  return focusedStudio;
}

export function navigateOutsideApp(url) {
  // OAuth providers and Stripe must open as a top-level page, even from the workspace.
  const target = isEmbeddedApp() ? window.parent : window;
  target.location.assign(url);
}
